import React, {useMemo} from 'react'
import {
  MenuCategoryDTO,
  ProductMap,
  PushClientDTO,
  RestaurantByProductMap,
} from 'grilnica-store-share'
import {Row} from 'grilnica-reactstrap'
import {ProductDTO} from 'grilnica-store-share/lib/product/ProductDTO'
import ProductItem from '../../../menu/components/product/productList/productItem/ProductItem'
import {getUrl} from '../../../../utils/search/getUrl'

interface NotificationPageOtherProductListProps {
  message: PushClientDTO
  productsOther: ProductDTO[]
  categoryList: MenuCategoryDTO[]
  productMap: ProductMap
  restaurantByProductMap: RestaurantByProductMap
  checkIsAddProduct: (productProp: ProductDTO) => ProductDTO
  colSize: any
}

const NotificationPageOtherProductList: React.FC<NotificationPageOtherProductListProps> = ({
  message,
  productsOther,
  categoryList,
  productMap,
  restaurantByProductMap,
  checkIsAddProduct,
  colSize,
}): React.ReactElement => {
  const renderContent: React.ReactElement = useMemo(() => {
    const items: React.ReactElement[] = []
    for (const productOther of productsOther) {
      const product = checkIsAddProduct(productOther)
      if (product) {
        let isNewPrice: boolean = false
        if (productOther?.price || productOther?.salePrice) {
          if (productOther?.price) {
            isNewPrice = productOther?.price !== product.price
          }
          if (productOther?.salePrice) {
            isNewPrice = productOther?.salePrice !== product.salePrice
          }
        }
        items.push(
          <ProductItem
            key={product.productId}
            product={product}
            productMap={productMap}
            restaurantByProductMap={restaurantByProductMap}
            url={getUrl(product, categoryList || [])}
            menuCategoryList={categoryList}
            colSize={colSize}
            pushQueueCoupon={message?.coupon ? message?.coupon : undefined}
            pushQueueId={message?.pushQueueId}
            isSendToBasketCombo //Отправка в корзину комбо а не открываем страницу
            isAddCouponWithProduct //Таже добовляем промокод в корзину
            isHiddenOptionsAndVariant //Скрыть отображение опций и вариантов товаров
            defaultProductValueMap={{
              weight: undefined,
              priceMap: isNewPrice
                ? {
                    price: productOther?.price,
                    salePrice: productOther?.salePrice,
                  }
                : undefined,
            }}
          />,
        )
      }
    }
    return <Row className={'product-list'}>{items}</Row>
  }, [
    productsOther,
    checkIsAddProduct,
    productMap,
    restaurantByProductMap,
    categoryList,
    colSize,
    message?.coupon,
    message?.pushQueueId,
  ])

  return <>{renderContent}</>
}

export {NotificationPageOtherProductList}
